<template>
  <div class="item-counter">
    <icon
      :name="icon"
      primaryColor="color-text-light"
      :size="isMobile ? 'xxs' : 'xs'" />
    <span class="item-counter-value">
      {{ value }}
    </span>
    <span class="item-counter-text">
      {{ text }}
    </span>
  </div>
</template>

<script>
import Icon from './Icon';
import Responsive from './../mixins/Responsive';

export default {
  name: 'item-counter',
  mixins: [
    Responsive
  ],
  props: [
    'icon',
    'value',
    'text'
  ],
  components: {
    'icon': Icon
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.item-counter {
  align-items: center;
  color: $color-text-light;
  display: flex;
  font-size: 1.1rem;

  &-value {
    background: $color-text-light;
    border: 2px solid $color-light;
    border-radius: 1rem;
    color: $color-light;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 1.2;
    margin-left: -.4rem;
    margin-right: .5rem;
    padding: .125rem .5rem;
    position: relative;
    text-align: center;
    top: 0;
  }
}

@media (max-width: 1360px) {
  .item-counter-text {
    display: none;
  }
}

@media (max-width: 640px) {
  .item-counter {
    font-size: .9rem;

    &-value {
      border-width: 1px;
      font-size: 1rem;
      line-height: 1.3;
      padding: .065rem .35rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ItemCounter.vue